import styled from 'styled-components';
import { Title as CardTitle } from '../../../../../components/v2/Card';

import colors from '../../../../../styles/colors';

const NotificationRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  border-radius: 8px;
  background-color: ${colors.shades.warning1};
  border: 1px solid ${colors.shades.primary3};
`;

const NotificationIconWrap = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background-color: ${colors.shades.primary7};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${colors.shades.primary6};
`;

const NotificationText = styled.div`
  flex: 1;
`;

const NotificationTitle = styled(CardTitle)`
  font-size: 16px;
`;

export {
  NotificationRow,
  NotificationIconWrap,
  NotificationText,
  NotificationTitle,
};
